import { createPopper } from '@popperjs/core';
function getPopTip() {
    // Create independent tip elements for each element
    if (!getPopTip.tips) {
        getPopTip.tips = new Map();
    }
    return getPopTip.tips;
}

function getOrCreateTip(el) {
    const tips = getPopTip();
    if (!tips.has(el)) {
        const tip = document.createElement('div');
        tip.className = 'pop-tip';
        tip.setAttribute('data-tip-id', Date.now() + Math.random());
        tips.set(el, tip);
    }
    return tips.get(el);
}
function handlerTip(el, binding) {
    let popTip = getOrCreateTip(el);
    let value;
    if (Object.prototype.toString.call(binding.value) === '[object Function]') {
        value = binding.value();
    } else {
        value = binding.value;
    }
    let { content, placement = 'top', show, maxWidth, autoShow } = value;

    // If autoShow is set, check if content overflows
    if (autoShow) {
        const isOverflowing = checkOverflow(el);
        console.log('Element overflow check:', {
            element: el,
            content: el.textContent,
            isOverflowing,
            scrollWidth: el.scrollWidth,
            clientWidth: el.clientWidth
        });
        if (!isOverflowing) {
            popTip.remove();
            return;
        }
    } else if (!show) {
        popTip.remove();
        return;
    }

    // Ensure tip element is in body
    if (!document.body.contains(popTip)) {
        document.body.append(popTip);
    }
    
    // Completely reset tip content
    popTip.innerHTML = '';
    popTip.style.maxWidth = maxWidth;
    
    // Set new content
    const contentDom = document.createElement('div');
    contentDom.innerHTML = content;
    popTip.appendChild(contentDom);
    
    calcPosition({ el, popTip, placement })
}

function checkOverflow(el) {
    // Check if element content overflows
    if (el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight) {
        return true;
    }
    
    // Check if text is truncated (for text-overflow: ellipsis cases)
    const style = window.getComputedStyle(el);
    if (style.textOverflow === 'ellipsis' && style.overflow === 'hidden') {
        return el.scrollWidth > el.clientWidth;
    }
    
    return false;
}

function calcPosition({ el, popTip, placement } = {}) {
    // Create arrow element
    const arrowDom = document.createElement('div')
    arrowDom.className = 'pop-tip-arrow';
    arrowDom.setAttribute('data-popper-arrow', '')
    popTip.appendChild(arrowDom)
    
    createPopper(el, popTip, {
        placement: placement,
        strategy: 'fixed',
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0, 10],
                }
            },
            {
                name: 'arrow',
                options: {
                    element: arrowDom,
                }
            },
            {
                name: 'preventOverflow',
                options: {
                    boundary: 'viewport',
                    padding: 8,
                },
            }
        ],
        onFirstUpdate: (state) => {
            placement = state.placement;
            popTip.className = `pop-tip pop-${placement}`;
        }
    });
}



export default Vue => {
    Vue.directive('tip', {
        mounted(el, binding) {
            const showTip = () => {
                // Get the latest binding value each time
                let value;
                if (Object.prototype.toString.call(binding.value) === '[object Function]') {
                    value = binding.value();
                } else {
                    value = binding.value;
                }
                
                // If autoShow is set, check if content overflows
                if (value.autoShow) {
                    const isOverflowing = checkOverflow(el);
                    if (!isOverflowing) {
                        return;
                    }
                }
                
                // Pass current binding directly, not tipInsBinding
                handlerTip(el, binding);
            };
            
            const hideTip = () => {
                const popTip = getOrCreateTip(el);
                popTip.remove();
            };
            
            el.addEventListener('mouseover', showTip);
            el.addEventListener('mouseout', hideTip);
            el.addEventListener('click', () => {
                let value;
                if (
                    Object.prototype.toString.call(binding.value) ===
                    '[object Function]'
                ) {
                    value = binding.value();
                } else {
                    value = binding.value;
                }
                let { clickDisappear } = value;
                if (clickDisappear) {
                    const popTip = getOrCreateTip(el);
                    popTip.remove();
                }
            });
        },
        updated(el, binding) {
            // No special handling needed on update, as binding value is re-fetched on each hover
        },
        unmounted(el) {
            // Clean up the tip corresponding to the element
            const tips = getPopTip();
            if (tips.has(el)) {
                const tip = tips.get(el);
                tip.remove();
                tips.delete(el);
            }
        }
    });
};
